import axios, { Axios } from "axios";
import { json } from "react-router-dom";
import axiosInstance from "src/hooks/axios-interceptor";
import { getServerInfo } from "src/util/auth";


export const controlBulb = (body) => {
    const url="http://192.168.1.36:1880"

 
    return axios
      .post(`${url}/control`, body, {
        
      })
      .then((response) => {
        //   if (!response.data.response[0].success) {
        //     return;
        //   }
        return response.data.response[0];
      })
      .catch((error) => {
        var response = catchAxiosError(error);
         return response;
      });
  };
  //private methods

const catchAxiosError = (error) => {
    if (!error.response) {
      // network error
      return json(
        {},
        {
          status: 404,
        }
      );
    } else {
      const code = error.response.status;
      const message = error.message;
      return { errors:[message]}
    }
  };